/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Subject_History14Inputs */

const en__field_enum_subject_history14 = /** @type {(inputs: _Field_Enum_Subject_History14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`History`)
};

const de__field_enum_subject_history14 = /** @type {(inputs: _Field_Enum_Subject_History14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschichte`)
};

/**
* | output |
* | --- |
* | "History" |
*
* @param {_Field_Enum_Subject_History14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_subject_history14 = /** @type {((inputs?: _Field_Enum_Subject_History14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Subject_History14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_subject_history14(inputs)
	return de__field_enum_subject_history14(inputs)
});
export { _field_enum_subject_history14 as "_field_enum_SUBJECT_HISTORY" }